import { CLEAR_USER_FILTER, SET_USERS_FILTER, SET_USER_PAGE_NUMBER } from '../types';

const initialState = {
    userFilter: null,
    pageNumber: 1,
};

const filterUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USERS_FILTER:
            return {
                ...state,
                userFilter: action.payload,
            };
        case SET_USER_PAGE_NUMBER:
            return {
                ...state,
                pageNumber: action.payload,
            };
        case CLEAR_USER_FILTER:
            return {
                ...state,
                userFilter: null,
                pageNumber: 1,
            };
        default:
            return state;
    }
};

export default filterUsersReducer;
